import { Link } from 'react-router';
import type { MultiLang } from '../../config';
import iconFile from '../assets/images/icon_folder.gif';
import IndexUtil, { type Index } from './IndexUtil';

interface Props {
    lang: MultiLang;
    index: Index;
}

const ListIndexItem = (props: Props) => {
    const url = IndexUtil.getUrl(props.index.id);
    const numOfIndexes = IndexUtil.countChildren(props.index.id);
    return (
        <table>
            <tbody>
                <tr>
                    <td className="listIcon">
                        <Link to={url}>
                            <img alt={props.index.title} src={iconFile} />
                        </Link>
                    </td>
                    <td>
                        <Link to={url}>{props.index.title}</Link>
                        <br />
                        {numOfIndexes} indexes / {props.index.numOfItems} items
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

const XoonipsListIndex = (props: Props) => {
    const { lang } = props;
    const children = IndexUtil.getChildren(props.index.id);
    if (children.length === 0) {
        return null;
    }
    const treeList = children.map((value: Index, idx) => {
        const evenodd = idx % 2 === 0 ? 'even' : 'odd';
        return (
            <tr key={value.id}>
                <td className={evenodd}>
                    <ListIndexItem lang={lang} index={value} />
                </td>
            </tr>
        );
    });
    return (
        <table className="listTable">
            <tbody>{treeList}</tbody>
        </table>
    );
};

export default XoonipsListIndex;
